module.exports = __webpack_public_path__ + "img/kv3.fd07d97.jpg";